var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1024 1024"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#35A4DD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 65,
    d: "M89 442.645v560.495c0 .56.448 1 1 1h288.5c.552 0 1-.44 1-1V622.645a1 1 0 011-1H647a1 1 0 011 1v380.495c0 .56.448 1 1 1h285c.553 0 1-.44 1-1V442.645"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M110.441 463.121L512.517 95.184l83.706 76.483 62.148 57.78c13.145 12.222 33.71 11.473 45.931-1.673 12.222-13.145 11.473-33.71-1.672-45.931l-62.25-57.875a35.98 35.98 0 00-.207-.191L535.098 27.769c-12.804-11.699-32.419-11.69-45.213.017L66.56 415.169c-13.242 12.117-14.154 32.675-2.036 45.917 12.117 13.241 32.675 14.153 45.917 2.035zM842.909 309.14c-13.258-12.1-33.814-11.162-45.914 2.096-12.1 13.258-11.161 33.814 2.096 45.914l114.5 104.5c13.258 12.1 33.815 11.162 45.915-2.096 12.099-13.258 11.161-33.814-2.097-45.914l-114.5-104.5zM750 305.145c17.949 0 32.5-14.551 32.5-32.5 0-17.949-14.551-32.5-32.5-32.5-17.949 0-32.5 14.551-32.5 32.5 0 17.949 14.551 32.5 32.5 32.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1024v1024H0z"
  })))));
}

export default SvgHome;